import React from "react";
import { authRoles } from "../../auth/authRoles";

const dashboardRoutes = [

  //----------Analytics------------
  {
    path: "/dashboard/analytics",
    component: React.lazy(() => import("./Analytics")),
    auth: authRoles.dashboard
  },
  {
    path: "/dashboard/analytics2",
    component: React.lazy(() => import("./Analytics2")),
    auth: authRoles.dashboard
  },
  

];

export default dashboardRoutes;
